<header class="navbar navbar-expand-lg  border-bottom header_bar hearder_color">
  <div class="container-fluid">
    <!-- Logo -->
    <div class="d-flex align-items-center logo" class="cursor_pointer">
      <img src="../../../../assets/image/logo 3.svg" alt="Logo" class="logo_img me-2">
    </div>
    <div class="scaits">
      <div (click)="toggleCollapse()">
        <span class="scaits_title" *ngIf="!isCollapsed">Grievance</span>
        <img class="nav_bar" *ngIf="!isCollapsed" src="../../../../assets/image/grievance/nav bar.svg">
        <img class="nav_bar_close" *ngIf="isCollapsed" src="../../../../assets/image/grievance/nav bar close.svg">
      </div>

    </div>




    <!-- Icons -->
 <div class="dropdown">
          <a class="btn user"  data-bs-toggle="dropdown" aria-expanded="false">
               <img src="../../../../assets/image/grievance/user-icon 1.svg" alt="User Avatar" class="avatar" />
          </a>
          <ul class="dropdown-menu user_details dropdown-left" (click)="$event.stopPropagation()">
            <li><a class="dropdown-item user_name">User Name : {{userName}}</a></li>
              <li><a class="dropdown-item campus_name">Campus Name : {{campusName}}</a></li>
            <li><button class="button" (click)="logOut()">Log out</button></li>
          </ul>
        </div>
  </div>
</header>